import { render, staticRenderFns } from "./EventHeaderMoreInfoModal.vue?vue&type=template&id=04608a1c"
import script from "./EventHeaderMoreInfoModal.vue?vue&type=script&lang=js"
export * from "./EventHeaderMoreInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports